import template from './information.html';
import controller from './information.controller';
import './information.scss';

let informationComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: "vm"
};

export default informationComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/information.component.js